/* Pepper Grey cart drawer + free postcard gift. Config comes from window.PG_DRAWER (snippets/pg-drawer.liquid). */
(function(){
  var C = window.PG_DRAWER; if (!C || window.pgDrawerReady) return; window.pgDrawerReady = true;
  var HEAD = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  var GIFT_HANDLE = 'free-pepper-grey-postcard', GIFT_MIN = 12000; /* $120.00 */
  var drawer = document.getElementById('pg-drawer'); if (!drawer) return;
  var bodyEl = drawer.querySelector('[data-pgd-body]'), countEl = drawer.querySelector('[data-pgd-count]'), live = drawer.querySelector('[data-pgd-live]');
  var lastFocus = null, isOpen = false, dogPending = null, dogTimer, giftId = null, syncing = false, acting = false;
  var nativeFetch = window.fetch.bind(window);

  function q(s){ return drawer.querySelector(s); }
  function say(t){ live.textContent = ''; setTimeout(function(){ live.textContent = t; }, 30); }
  function post(url, body){
    return nativeFetch(url, {method: 'POST', credentials: 'same-origin', headers: HEAD, body: JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
  }
  function getCart(){ return nativeFetch(C.cart + '.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); }
  function setCount(n){
    [].forEach.call(document.querySelectorAll('[data-cart-count]'), function(el){ el.textContent = n; });
    countEl.textContent = n ? ' (' + n + ')' : '';
  }

  /* Free postcard: added automatically at $120+, removed if the order drops below */
  function getGiftId(){
    if (giftId) return Promise.resolve(giftId);
    return nativeFetch(C.root.replace(/\/$/, '') + '/products/' + GIFT_HANDLE + '.js').then(function(r){ return r.json(); })
      .then(function(p){ giftId = p.variants[0].id; return giftId; }).catch(function(){ return null; });
  }
  function syncGift(cart){
    return getGiftId().then(function(id){
      if (!id || syncing || !cart) return false;
      var idx = -1, gq = 0, others = false;
      cart.items.forEach(function(it, i){ if (it.variant_id === id) { if (idx < 0) idx = i; gq += it.quantity; } else others = true; });
      var want = others && cart.total_price >= GIFT_MIN;
      var job = null;
      if (want && idx < 0) job = post(C.add, {items: [{id: id, quantity: 1, properties: {'_Free gift': 'Orders over $120'}}]});
      else if (want && gq > 1) job = post(C.change, {line: idx + 1, quantity: 1});
      else if (!want && idx >= 0) job = post(C.change, {line: idx + 1, quantity: 0});
      if (!job) return false;
      syncing = true;
      return job.then(function(){ return true; }, function(){ return false; }).finally(function(){ syncing = false; });
    });
  }
  function syncAndRefreshPage(){
    return getCart().then(syncGift).then(function(changed){
      if (!changed) return;
      if (isOpen) render();
      if (C.onCartPage) { if (window.pgCartRefresh) window.pgCartRefresh(); else window.location.reload(); }
      getCart().then(function(c){ setCount(c.item_count); });
    }).catch(function(){});
  }

  function hydrateDog(cart){
    var dog = q('[data-pgd-dog]'); if (!dog) return;
    var v = (cart && cart.attributes && cart.attributes[C.dogKey]) || '';
    if (dogPending === null && document.activeElement !== dog) dog.value = v;
    var wrap = q('[data-pgd-dogwrap]'); if (wrap && v) wrap.open = true;
  }
  function render(){
    bodyEl.setAttribute('aria-busy', 'true');
    var scroll = q('.pgd__scroll'), top = scroll ? scroll.scrollTop : 0, upEl = q('.pgd-up__list'), upLeft = upEl ? upEl.scrollLeft : 0;
    return getCart().then(function(c){ return syncGift(c).then(function(ch){ return ch ? getCart() : c; }); })
      .then(function(cart){
        return nativeFetch(C.root.replace(/\/$/, '') + '/?sections=pg-drawer-body', {credentials: 'same-origin'}).then(function(r){ return r.json(); })
          .then(function(sec){
            bodyEl.innerHTML = sec['pg-drawer-body'] || '';
            setCount(cart.item_count);
            hydrateDog(cart);
            var s2 = q('.pgd__scroll'); if (s2) s2.scrollTop = top;
            var u2 = q('.pgd-up__list'); if (u2) u2.scrollLeft = upLeft;
          });
      }).catch(function(){
        bodyEl.innerHTML = '<div class="pgd__load">Sorry, your cart could not load. <a href="' + C.cart + '">View cart</a></div>';
      }).finally(function(){ bodyEl.removeAttribute('aria-busy'); });
  }
  function focusables(){ return [].filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input,summary,[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetParent !== null || el.classList.contains('pgd-ot__in'); }); }
  function open(){
    if (!isOpen) {
      lastFocus = document.activeElement; isOpen = true;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pgd-open');
      setTimeout(function(){ var x = q('.pgd__x'); if (x) x.focus(); }, 60);
    }
    return render();
  }
  function close(){
    if (!isOpen) return;
    saveDog(); isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pgd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.PGDrawer = {open: open, close: close, refresh: render, syncGift: syncAndRefreshPage};

  function saveDog(){
    if (dogPending === null) return Promise.resolve();
    var v = dogPending.trim(); clearTimeout(dogTimer);
    var a = {}; a[C.dogKey] = v;
    return post(C.update, {attributes: a}).then(function(){
      dogPending = null;
      var ok = q('[data-pgd-dogok]'); if (ok) ok.textContent = v ? 'Saved! We’ll write a little note for ' + v + '.' : '';
    }).catch(function(){ dogPending = null; });
  }
  function act(fn, msg){
    if (acting) return Promise.resolve();
    acting = true;
    bodyEl.setAttribute('aria-busy', 'true');
    return saveDog().then(fn).then(render).then(function(){ if (msg) say(msg); })
      .catch(function(err){
        return render().then(function(){ var e = q('[data-pgd-err]'); if (e) e.textContent = (err && err.description) || 'Sorry, something went wrong. Please try again.'; });
      }).finally(function(){ acting = false; });
  }
  function addVariant(id, from){ return post(C.add, {items: [{id: +id, quantity: 1, properties: {'_Added from': from}}]}); }

  document.addEventListener('click', function(e){
    if (C.onCartPage) return;
    var a = e.target.closest('a[href="/cart"], a[href="' + C.cart + '"], [data-drawer-options*="mini_cart"]');
    if (!a || drawer.contains(a)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);

  drawer.addEventListener('click', function(e){
    if (e.target.closest('[data-pgd-close]')) { close(); return; }
    if (acting) return;
    var qb = e.target.closest('[data-pgd-q]');
    if (qb) {
      var li = qb.closest('.pgd-it'), qty = (+li.dataset.qty) + (+qb.dataset.pgdQ);
      if (qty < 1) return;
      act(function(){ return post(C.change, {line: +li.dataset.line, quantity: qty}); }, 'Cart updated.');
      return;
    }
    var rm = e.target.closest('[data-pgd-rm]');
    if (rm) { var l2 = rm.closest('.pgd-it'); act(function(){ return post(C.change, {line: +l2.dataset.line, quantity: 0}); }, 'Item removed.'); return; }
    var add = e.target.closest('[data-pgd-add]');
    if (add) { add.textContent = 'Adding…'; add.disabled = true; act(function(){ return addVariant(add.dataset.pgdAdd, 'Cart add-on'); }, 'Added to your cart.'); }
  });
  document.querySelector('.pgd-ov').addEventListener('click', close);

  drawer.addEventListener('input', function(e){
    if (!e.target.matches('[data-pgd-dog]')) return;
    dogPending = e.target.value; clearTimeout(dogTimer);
    var ok = q('[data-pgd-dogok]'); if (ok) ok.textContent = '';
    dogTimer = setTimeout(saveDog, 700);
  });
  drawer.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && e.target.matches('[data-pgd-dog]')) { e.preventDefault(); dogPending = e.target.value; saveDog(); }
  });
  drawer.addEventListener('submit', function(e){
    if (dogPending === null) return;
    e.preventDefault();
    var f = e.target;
    saveDog().then(function(){ var b = document.createElement('input'); b.type = 'hidden'; b.name = 'checkout'; b.value = '1'; f.appendChild(b); f.submit(); });
  });
  document.addEventListener('keydown', function(e){
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* Watch cart changes made by the rest of the site */
  function isAdd(url){ return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
  function isCartChange(url){ return /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(String(url || '')); }
  function isMixBuilder(body){ return typeof body === 'string' && body.indexOf('Mix & Match') > -1; }
  var syncTimer;
  function laterSync(){ clearTimeout(syncTimer); syncTimer = setTimeout(syncAndRefreshPage, 400); }
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = nativeFetch(input, init);
    if (isAdd(url) && !C.onCartPage && !isMixBuilder(init && init.body)) {
      p.then(function(r){ if (r.ok) setTimeout(open, 150); }).catch(function(){});
    } else if (isAdd(url) || isCartChange(url)) {
      p.then(function(r){ if (r.ok) laterSync(); }).catch(function(){});
    }
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, url){ this._pgAdd = isAdd(url); this._pgChg = isCartChange(url); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(body){
    var x = this;
    if (x._pgAdd && !C.onCartPage && !isMixBuilder(body)) x.addEventListener('load', function(){ if (x.status < 400) setTimeout(open, 150); });
    else if (x._pgAdd || x._pgChg) x.addEventListener('load', function(){ if (x.status < 400) laterSync(); });
    return xs.apply(this, arguments);
  };
  getCart().then(function(c){ countEl.textContent = c.item_count ? ' (' + c.item_count + ')' : ''; }).then(syncAndRefreshPage).catch(function(){});
})();
